<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/products/private-label-market',
    'fr-CA': '/produits/segment-marques-privees'
  }
})

useHead({
  title: t('navigation.privateLabelMarket.metatitle'),
  meta: [{ name: 'description', content: t('navigation.privateLabelMarket.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('products-products')">{{ $t('navigation.products.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.privateLabelMarket.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.privateLabelMarket.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuProducts />
        <div class="contenu right">
          <div class=""
               v-if="$i18n.locale == 'en-CA'">
            <p>Kruger Products Inc. also manufactures private label tissue products for customers in the U.S. and Canada. The U.S. private label business has grown substantially since 2004. Management believes the opportunity to penetrate the U.S. market with high quality products represents a significant opportunity.</p>
            <p>The Through-Air-Drying (TAD) facility in Memphis, Tennessee is a key component of the strategy to grow revenues in the U.S. private label market, the fastest growing segment of the tissue industry according to ACNielsen data.</p>
          </div>
          <div class=""
               v-if="$i18n.locale == 'fr-CA'">
            <p>Produits Kruger inc. fabrique également des produits de papier de marques privées pour les consommateurs des États-Unis et du Canada. Ce segment connaît d'ailleurs une bonne croissance au sud de la frontière depuis 2004. La direction estime qu'une éventuelle percée sur le marché américain avec des produits de qualité supérieure représente une importante occasion d'affaires.</p>
            <p>L'appareil TAD (Through-Air-Drying) de l'usine de Memphis, au Tennessee, est un élément clé de la stratégie de croissance du segment des marques privées aux États-Unis, qui est, selon les données d'ACNielsen, le segment à plus forte croissance de l'industrie du papier.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
